export const getUrlParam = (url, name, defaultValue = '') => {
    const query = url.split('?')[1] || '';
    const params = query.split('&');
    const param = params.find(p => p.startsWith(`${name}=`));
    return (param || `${name}=${defaultValue}`).split('=')[1];
};



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-authenticators/manage/getUrlParam.js